import { render, staticRenderFns } from "./MealCategoryDelete.vue?vue&type=template&id=47163320&scoped=true"
import script from "./MealCategoryDelete.vue?vue&type=script&lang=js"
export * from "./MealCategoryDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47163320",
  null
  
)

export default component.exports